import { CustomForm, CustomFormControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useFormBuilderUpdate = () =>
  useMutationWithLoading(
    async (param: { customForm: CustomForm; xTENANTID?: string }) =>
      new CustomFormControllerApi(getConfigObject()).updateCustomForm1(
        param?.customForm,
        param?.xTENANTID
      )
  );
